export default [
  {
    name: "Afghanistan",
    dial_code: "+93",
    code: "AF",
    flag: "🇦🇫",
    local_name: "افغانستان",
    currency: "Afghan Afghani",
    currency_code: "AFN",
    currency_symbol: "؋",
  },
  {
    name: "Albania",
    dial_code: "+355",
    code: "AL",
    flag: "🇦🇱",
    local_name: "Shqipëria",
    currency: "Albanian Lek",
    currency_code: "ALL",
    currency_symbol: "L",
  },
  {
    name: "Algeria",
    dial_code: "+213",
    code: "DZ",
    flag: "🇩🇿",
    local_name: "Dzayer",
    currency: "Algerian Dinar",
    currency_code: "DZD",
    currency_symbol: "د.ج",
  },
  {
    name: "American Samoa",
    dial_code: "+1684",
    code: "AS",
    flag: "🇦🇸",
    part_of: ["US"],
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Andorra",
    dial_code: "+376",
    code: "AD",
    flag: "🇦🇩",
    local_name: "Andorra",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Angola",
    dial_code: "+244",
    code: "AO",
    flag: "🇦🇴",
    local_name: "Angola",
    currency: "Angolan Kwanza",
    currency_code: "AOA",
    currency_symbol: "Kz",
  },
  {
    name: "Anguilla",
    dial_code: "+1264",
    code: "AI",
    flag: "🇦🇮",
    local_name: "Anguilla",
    part_of: ["GB"],
    currency: "East Caribbean Dollar",
    currency_code: "XCD",
    currency_symbol: "$",
  },
  {
    name: "Antarctica",
    dial_code: "+672",
    code: "AQ",
    flag: "🇦🇶",
    currency: "",
    currency_code: "",
    currency_symbol: "",
  },
  {
    name: "Antigua and Barbuda",
    dial_code: "+1268",
    code: "AG",
    flag: "🇦🇬",
    local_name: "Antigua and Barbuda",
    currency: "East Caribbean Dollar",
    currency_code: "XCD",
    currency_symbol: "$",
  },
  {
    name: "Argentina",
    dial_code: "+54",
    code: "AR",
    flag: "🇦🇷",
    local_name: "Argentina",
    currency: "Argentine Peso",
    currency_code: "ARS",
    currency_symbol: "$",
  },
  {
    name: "Armenia",
    dial_code: "+374",
    code: "AM",
    flag: "🇦🇲",
    local_name: "Հայաստան",
    currency: "Armenian Dram",
    currency_code: "AMD",
    currency_symbol: "֏",
  },
  {
    name: "Aruba",
    dial_code: "+297",
    code: "AW",
    flag: "🇦🇼",
    part_of: ["NL"],
    local_name: "Aruba",
    currency: "Aruban Florin",
    currency_code: "AWG",
    currency_symbol: "ƒ",
  },
  {
    name: "Australia",
    dial_code: "+61",
    code: "AU",
    preferred: !0,
    flag: "🇦🇺",
    local_name: "Australia",
    currency: "Australian Dollar",
    currency_code: "AUD",
    currency_symbol: "$",
  },
  {
    name: "Austria",
    dial_code: "+43",
    code: "AT",
    flag: "🇦🇹",
    local_name: "Österreich",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Azerbaijan",
    dial_code: "+994",
    code: "AZ",
    flag: "🇦🇿",
    local_name: "Azərbaycan",
    currency: "Azerbaijani Manat",
    currency_code: "AZN",
    currency_symbol: "₼",
  },
  {
    name: "Bahamas",
    dial_code: "+1242",
    code: "BS",
    flag: "🇧🇸",
    local_name: "The Bahamas",
    currency: "Bahamian Dollar",
    currency_code: "BSD",
    currency_symbol: "$",
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
    flag: "🇧🇭",
    local_name: "البحرين",
    currency: "Bahraini Dinar",
    currency_code: "BHD",
    currency_symbol: ".د.ب",
  },
  {
    name: "Bangladesh",
    dial_code: "+880",
    code: "BD",
    flag: "🇧🇩",
    local_name: "বাংলাদেশ",
    currency: "Bangladeshi Taka",
    currency_code: "BDT",
    currency_symbol: "৳",
  },
  {
    name: "Barbados",
    dial_code: "+1246",
    code: "BB",
    flag: "🇧🇧",
    local_name: "Barbados",
    currency: "Barbadian Dollar",
    currency_code: "BBD",
    currency_symbol: "$",
  },
  {
    name: "Belarus",
    dial_code: "+375",
    code: "BY",
    flag: "🇧🇾",
    local_name: "Беларусь",
    currency: "Belarusian Ruble",
    currency_code: "BYN",
    currency_symbol: "Br",
  },
  {
    name: "Belgium",
    dial_code: "+32",
    code: "BE",
    flag: "🇧🇪",
    local_name: "België",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Belize",
    dial_code: "+501",
    code: "BZ",
    flag: "🇧🇿",
    local_name: "Belize",
    currency: "Belize Dollar",
    currency_code: "BZD",
    currency_symbol: "$",
  },
  {
    name: "Benin",
    dial_code: "+229",
    code: "BJ",
    flag: "🇧🇯",
    local_name: "Bénin",
    currency: "West African CFA Franc",
    currency_code: "XOF",
    currency_symbol: "CFA",
  },
  {
    name: "Bermuda",
    dial_code: "+1441",
    code: "BM",
    flag: "🇧🇲",
    part_of: ["GB"],
    local_name: "Bermuda",
    currency: "Bermudian Dollar",
    currency_code: "BMD",
    currency_symbol: "$",
  },
  {
    name: "Bhutan",
    dial_code: "+975",
    code: "BT",
    flag: "🇧🇹",
    local_name: "འབྲུག་ཡུལ",
    currency: "Bhutanese Ngultrum",
    currency_code: "BTN",
    currency_symbol: "Nu.",
  },
  {
    name: "Bolivia, Plurinational State of",
    dial_code: "+591",
    code: "BO",
    flag: "🇧🇴",
    local_name: "Bolivia",
    currency: "Bolivian Boliviano",
    currency_code: "BOB",
    currency_symbol: "Bs.",
  },
  {
    name: "Bosnia and Herzegovina",
    dial_code: "+387",
    code: "BA",
    flag: "🇧🇦",
    local_name: "Bosna i Hercegovina",
    currency: "Bosnia and Herzegovina Convertible Mark",
    currency_code: "BAM",
    currency_symbol: "KM",
  },
  {
    name: "Botswana",
    dial_code: "+267",
    code: "BW",
    flag: "🇧🇼",
    local_name: "Botswana",
    currency: "Botswana Pula",
    currency_code: "BWP",
    currency_symbol: "P",
  },
  {
    name: "Brazil",
    dial_code: "+55",
    code: "BR",
    flag: "🇧🇷",
    local_name: "Brasil",
    currency: "Brazilian Real",
    currency_code: "BRL",
    currency_symbol: "R$",
  },
  {
    name: "British Indian Ocean Territory",
    dial_code: "+246",
    code: "IO",
    flag: "🇮🇴",
    part_of: ["GB"],
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Brunei Darussalam",
    dial_code: "+673",
    code: "BN",
    flag: "🇧🇳",
    local_name: "بروني",
    currency: "Brunei Dollar",
    currency_code: "BND",
    currency_symbol: "$",
  },
  {
    name: "Bulgaria",
    dial_code: "+359",
    code: "BG",
    flag: "🇧🇬",
    local_name: "България",
    currency: "Bulgarian Lev",
    currency_code: "BGN",
    currency_symbol: "лв",
  },
  {
    name: "Burkina Faso",
    dial_code: "+226",
    code: "BF",
    flag: "🇧🇫",
    local_name: "Burkina Faso",
    currency: "West African CFA Franc",
    currency_code: "XOF",
    currency_symbol: "CFA",
  },
  {
    name: "Burundi",
    dial_code: "+257",
    code: "BI",
    flag: "🇧🇮",
    local_name: "Burundi",
    currency: "Burundian Franc",
    currency_code: "BIF",
    currency_symbol: "FBu",
  },
  {
    name: "Cambodia",
    dial_code: "+855",
    code: "KH",
    flag: "🇰🇭",
    local_name: "កម្ពុជា",
    currency: "Cambodian Riel",
    currency_code: "KHR",
    currency_symbol: "៛",
  },
  {
    name: "Cameroon",
    dial_code: "+237",
    code: "CM",
    flag: "🇨🇲",
    local_name: "Cameroun",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    currency_symbol: "FCFA",
  },
  {
    name: "Canada",
    dial_code: "+1",
    code: "CA",
    flag: "🇨🇦",
    local_name: "Canada",
    currency: "Canadian Dollar",
    currency_code: "CAD",
    currency_symbol: "$",
  },
  {
    name: "Cape Verde",
    dial_code: "+238",
    code: "CV",
    flag: "🇨🇻",
    local_name: "Cabo Verde",
    currency: "Cape Verdean Escudo",
    currency_code: "CVE",
    currency_symbol: "$",
  },
  {
    name: "Cayman Islands",
    dial_code: "+345",
    code: "KY",
    flag: "🇰🇾",
    part_of: ["GB"],
    local_name: "Cayman Islands",
    currency: "Cayman Islands Dollar",
    currency_code: "KYD",
    currency_symbol: "$",
  },
  {
    name: "Central African Republic",
    dial_code: "+236",
    code: "CF",
    flag: "🇨🇫",
    local_name: "République centrafricaine",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    currency_symbol: "FCFA",
  },
  {
    name: "Chad",
    dial_code: "+235",
    code: "TD",
    flag: "🇹🇩",
    local_name: "Tchad",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    currency_symbol: "FCFA",
  },
  {
    name: "Chile",
    dial_code: "+56",
    code: "CL",
    flag: "🇨🇱",
    local_name: "Chile",
    currency: "Chilean Peso",
    currency_code: "CLP",
    currency_symbol: "$",
  },
  {
    name: "China",
    dial_code: "+86",
    code: "CN",
    flag: "🇨🇳",
    local_name: "中国",
    currency: "Chinese Yuan",
    currency_code: "CNY",
    currency_symbol: "¥",
  },
  {
    name: "Christmas Island",
    dial_code: "+61",
    code: "CX",
    flag: "🇨🇽",
    part_of: ["AU"],
    local_name: "Christmas Island",
    currency: "Australian Dollar",
    currency_code: "AUD",
    currency_symbol: "$",
  },
  {
    name: "Cocos (Keeling) Islands",
    dial_code: "+61",
    code: "CC",
    flag: "🇨🇨",
    part_of: ["AU"],
    local_name: "Cocos (Keeling) Islands",
    currency: "Australian Dollar",
    currency_code: "AUD",
    currency_symbol: "$",
  },
  {
    name: "Colombia",
    dial_code: "+57",
    code: "CO",
    flag: "🇨🇴",
    local_name: "Colombia",
    currency: "Colombian Peso",
    currency_code: "COP",
    currency_symbol: "$",
  },
  {
    name: "Comoros",
    dial_code: "+269",
    code: "KM",
    flag: "🇰🇲",
    local_name: "جزر القمر",
    currency: "Comorian Franc",
    currency_code: "KMF",
    currency_symbol: "CF",
  },
  {
    name: "Congo",
    dial_code: "+242",
    code: "CG",
    flag: "🇨🇬",
    local_name: "République du Congo",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    currency_symbol: "FCFA",
  },
  {
    name: "Congo, The Democratic Republic of the",
    dial_code: "+243",
    code: "CD",
    flag: "🇨🇩",
    local_name: "République démocratique du Congo",
    currency: "Congolese Franc",
    currency_code: "CDF",
    currency_symbol: "FC",
  },
  {
    name: "Cook Islands",
    dial_code: "+682",
    code: "CK",
    flag: "🇨🇰",
    local_name: "Cook Islands",
    currency: "New Zealand Dollar",
    currency_code: "NZD",
    currency_symbol: "$",
  },
  {
    name: "Costa Rica",
    dial_code: "+506",
    code: "CR",
    flag: "🇨🇷",
    local_name: "Costa Rica",
    currency: "Costa Rican Colón",
    currency_code: "CRC",
    currency_symbol: "₡",
  },
  {
    name: "Cote d'Ivoire",
    dial_code: "+225",
    code: "CI",
    flag: "🇨🇮",
    local_name: "Côte d'Ivoire",
    currency: "West African CFA Franc",
    currency_code: "XOF",
    currency_symbol: "CFA",
  },
  {
    name: "Croatia",
    dial_code: "+385",
    code: "HR",
    flag: "🇭🇷",
    local_name: "Hrvatska",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Cuba",
    dial_code: "+53",
    code: "CU",
    flag: "🇨🇺",
    local_name: "Cuba",
    currency: "Cuban Peso",
    currency_code: "CUP",
    currency_symbol: "$",
  },
  {
    name: "Curaçao",
    dial_code: "+599",
    code: "CW",
    flag: "🇨🇼",
    part_of: ["NL"],
    local_name: "Curaçao",
    currency: "Netherlands Antillean Guilder",
    currency_code: "ANG",
    currency_symbol: "ƒ",
  },
  {
    name: "Cyprus",
    dial_code: "+357",
    code: "CY",
    flag: "🇨🇾",
    local_name: "Κύπρος",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Czechia",
    dial_code: "+420",
    code: "CZ",
    flag: "🇨🇿",
    local_name: "Česko",
    currency: "Czech Koruna",
    currency_code: "CZK",
    currency_symbol: "Kč",
  },
  {
    name: "Canary Islands",
    dial_code: "+34",
    code: "IC",
    flag: "🇮🇨",
    part_of: ["ES"],
    local_name: "Islas Canarias",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Denmark",
    dial_code: "+45",
    code: "DK",
    flag: "🇩🇰",
    local_name: "Danmark",
    currency: "Danish Krone",
    currency_code: "DKK",
    currency_symbol: "kr",
  },
  {
    name: "Djibouti",
    dial_code: "+253",
    code: "DJ",
    flag: "🇩🇯",
    local_name: "جيبوتي",
    currency: "Djiboutian Franc",
    currency_code: "DJF",
    currency_symbol: "Fdj",
  },
  {
    name: "Dominica",
    dial_code: "+1767",
    code: "DM",
    flag: "🇩🇲",
    local_name: "Dominica",
    currency: "East Caribbean Dollar",
    currency_code: "XCD",
    currency_symbol: "$",
  },
  {
    name: "Dominican Republic",
    dial_code: "+1849",
    code: "DO",
    flag: "🇩🇴",
    local_name: "República Dominicana",
    currency: "Dominican Peso",
    currency_code: "DOP",
    currency_symbol: "$",
    country_code: "+1",
    area_codes: ["849", "829", "809"],
  },
  {
    name: "Dominican Republic",
    dial_code: "+1829",
    code: "DO",
    flag: "🇩🇴",
    secondary: !0,
    local_name: "República Dominicana",
    currency: "Dominican Peso",
    currency_code: "DOP",
    currency_symbol: "$",
  },
  {
    name: "Dominican Republic",
    dial_code: "+1809",
    code: "DO",
    flag: "🇩🇴",
    secondary: !0,
    local_name: "República Dominicana",
    currency: "Dominican Peso",
    currency_code: "DOP",
    currency_symbol: "$",
  },
  {
    name: "Ecuador",
    dial_code: "+593",
    code: "EC",
    flag: "🇪🇨",
    local_name: "Ecuador",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Egypt",
    dial_code: "+20",
    code: "EG",
    flag: "🇪🇬",
    local_name: "مصر",
    currency: "Egyptian Pound",
    currency_code: "EGP",
    currency_symbol: "E£",
  },
  {
    name: "El Salvador",
    dial_code: "+503",
    code: "SV",
    flag: "🇸🇻",
    local_name: "El Salvador",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Equatorial Guinea",
    dial_code: "+240",
    code: "GQ",
    flag: "🇬🇶",
    local_name: "Guinea Ecuatorial",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    currency_symbol: "FCFA",
  },
  {
    name: "Eritrea",
    dial_code: "+291",
    code: "ER",
    flag: "🇪🇷",
    local_name: "ኤርትራ",
    currency: "Eritrean Nakfa",
    currency_code: "ERN",
    currency_symbol: "Nfk",
  },
  {
    name: "Estonia",
    dial_code: "+372",
    code: "EE",
    flag: "🇪🇪",
    local_name: "Eesti",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Eswatini",
    dial_code: "+268",
    code: "SZ",
    flag: "🇸🇿",
    local_name: "eSwatini",
    currency: "Swazi Lilangeni",
    currency_code: "SZL",
    currency_symbol: "L",
  },
  {
    name: "Ethiopia",
    dial_code: "+251",
    code: "ET",
    flag: "🇪🇹",
    local_name: "ኢትዮጵያ",
    currency: "Ethiopian Birr",
    currency_code: "ETB",
    currency_symbol: "Br",
  },
  {
    name: "Falkland Islands (Malvinas)",
    dial_code: "+500",
    code: "FK",
    flag: "🇫🇰",
    part_of: ["GB"],
    local_name: "Falkland Islands",
    currency: "Falkland Islands Pound",
    currency_code: "FKP",
    currency_symbol: "£",
  },
  {
    name: "Faroe Islands",
    dial_code: "+298",
    code: "FO",
    flag: "🇫🇴",
    part_of: ["DK"],
    local_name: "Føroyar",
    currency: "Faroese Króna",
    currency_code: "DKK",
    currency_symbol: "kr",
  },
  {
    name: "Fiji",
    dial_code: "+679",
    code: "FJ",
    flag: "🇫🇯",
    local_name: "Fiji",
    currency: "Fijian Dollar",
    currency_code: "FJD",
    currency_symbol: "$",
  },
  {
    name: "Finland",
    dial_code: "+358",
    code: "FI",
    flag: "🇫🇮",
    local_name: "Suomi",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "France",
    dial_code: "+33",
    code: "FR",
    flag: "🇫🇷",
    local_name: "France",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "French Guiana",
    dial_code: "+594",
    code: "GF",
    flag: "🇬🇫",
    part_of: ["FR"],
    local_name: "Guyane française",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "French Polynesia",
    dial_code: "+689",
    code: "PF",
    flag: "🇵🇫",
    part_of: ["FR"],
    local_name: "Polynésie française",
    currency: "CFP Franc",
    currency_code: "XPF",
    currency_symbol: "₣",
  },
  {
    name: "French Southern Territories",
    dial_code: "+262",
    code: "TF",
    flag: "🇹🇫",
    part_of: ["FR"],
    local_name: "Terres australes françaises",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Gabon",
    dial_code: "+241",
    code: "GA",
    flag: "🇬🇦",
    local_name: "Gabon",
    currency: "Central African CFA Franc",
    currency_code: "XAF",
    currency_symbol: "FCFA",
  },
  {
    name: "Gambia",
    dial_code: "+220",
    code: "GM",
    flag: "🇬🇲",
    local_name: "The Gambia",
    currency: "Gambian Dalasi",
    currency_code: "GMD",
    currency_symbol: "D",
  },
  {
    name: "Georgia",
    dial_code: "+995",
    code: "GE",
    flag: "🇬🇪",
    local_name: "საქართველო",
    currency: "Georgian Lari",
    currency_code: "GEL",
    currency_symbol: "₾",
  },
  {
    name: "Germany",
    dial_code: "+49",
    code: "DE",
    flag: "🇩🇪",
    local_name: "Deutschland",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Ghana",
    dial_code: "+233",
    code: "GH",
    flag: "🇬🇭",
    local_name: "Ghana",
    currency: "Ghanaian Cedi",
    currency_code: "GHS",
    currency_symbol: "₵",
  },
  {
    name: "Gibraltar",
    dial_code: "+350",
    code: "GI",
    flag: "🇬🇮",
    part_of: ["GB"],
    local_name: "Gibraltar",
    currency: "Gibraltar Pound",
    currency_code: "GIP",
    currency_symbol: "£",
  },
  {
    name: "Greece",
    dial_code: "+30",
    code: "GR",
    flag: "🇬🇷",
    local_name: "Ελλάς",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Greenland",
    dial_code: "+299",
    code: "GL",
    flag: "🇬🇱",
    part_of: ["DK"],
    local_name: "Kalaallit Nunaat",
    currency: "Danish Krone",
    currency_code: "DKK",
    currency_symbol: "kr",
  },
  {
    name: "Grenada",
    dial_code: "+1473",
    code: "GD",
    flag: "🇬🇩",
    local_name: "Grenada",
    currency: "East Caribbean Dollar",
    currency_code: "XCD",
    currency_symbol: "$",
  },
  {
    name: "Guadeloupe",
    dial_code: "+590",
    code: "GP",
    flag: "🇬🇵",
    part_of: ["FR"],
    local_name: "Guadeloupe",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Guam",
    dial_code: "+1671",
    code: "GU",
    flag: "🇬🇺",
    part_of: ["US"],
    local_name: "Guam",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Guatemala",
    dial_code: "+502",
    code: "GT",
    flag: "🇬🇹",
    local_name: "Guatemala",
    currency: "Guatemalan Quetzal",
    currency_code: "GTQ",
    currency_symbol: "Q",
  },
  {
    name: "Guernsey",
    dial_code: "+44",
    code: "GG",
    flag: "🇬🇬",
    part_of: ["GB"],
    local_name: "Guernsey",
    currency: "Guernsey Pound",
    currency_code: "GGP",
    currency_symbol: "£",
  },
  {
    name: "Guinea",
    dial_code: "+224",
    code: "GN",
    flag: "🇬🇳",
    local_name: "Guinée",
    currency: "Guinean Franc",
    currency_code: "GNF",
    currency_symbol: "FG",
  },
  {
    name: "Guinea-Bissau",
    dial_code: "+245",
    code: "GW",
    flag: "🇬🇼",
    local_name: "Guiné-Bissau",
    currency: "West African CFA Franc",
    currency_code: "XOF",
    currency_symbol: "CFA",
  },
  {
    name: "Guyana",
    dial_code: "+592",
    code: "GY",
    flag: "🇬🇾",
    local_name: "Guyana",
    currency: "Guyanese Dollar",
    currency_code: "GYD",
    currency_symbol: "$",
  },
  {
    name: "Haiti",
    dial_code: "+509",
    code: "HT",
    flag: "🇭🇹",
    local_name: "Haïti",
    currency: "Haitian Gourde",
    currency_code: "HTG",
    currency_symbol: "G",
  },
  {
    name: "Heard & McDonald Islands",
    dial_code: "+672",
    code: "HM",
    flag: "🇭🇲",
    part_of: ["AU"],
    local_name: "Heard & McDonald Islands",
    currency: "Australian Dollar",
    currency_code: "AUD",
    currency_symbol: "$",
  },
  {
    name: "Holy See (Vatican City State)",
    dial_code: "+379",
    code: "VA",
    flag: "🇻🇦",
    local_name: "Città del Vaticano",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Honduras",
    dial_code: "+504",
    code: "HN",
    flag: "🇭🇳",
    local_name: "Honduras",
    currency: "Honduran Lempira",
    currency_code: "HNL",
    currency_symbol: "L",
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    code: "HK",
    flag: "🇭🇰",
    local_name: "香港",
    part_of: ["CN"],
    currency: "Hong Kong Dollar",
    currency_code: "HKD",
    currency_symbol: "$",
  },
  {
    name: "Hungary",
    dial_code: "+36",
    code: "HU",
    flag: "🇭🇺",
    local_name: "Magyarország",
    currency: "Hungarian Forint",
    currency_code: "HUF",
    currency_symbol: "Ft",
  },
  {
    name: "Iceland",
    dial_code: "+354",
    code: "IS",
    flag: "🇮🇸",
    local_name: "Ísland",
    currency: "Icelandic Króna",
    currency_code: "ISK",
    currency_symbol: "kr",
  },
  {
    name: "India",
    dial_code: "+91",
    code: "IN",
    preferred: !0,
    flag: "🇮🇳",
    local_name: "भारत",
    currency: "Indian Rupee",
    currency_code: "INR",
    currency_symbol: "₹",
  },
  {
    name: "Indonesia",
    dial_code: "+62",
    code: "ID",
    flag: "🇮🇩",
    local_name: "Indonesia",
    currency: "Indonesian Rupiah",
    currency_code: "IDR",
    currency_symbol: "Rp",
  },
  {
    name: "Iran, Islamic Republic of",
    dial_code: "+98",
    code: "IR",
    flag: "🇮🇷",
    local_name: "ایران",
    currency: "Iranian Rial",
    currency_code: "IRR",
    currency_symbol: "﷼",
  },
  {
    name: "Iraq",
    dial_code: "+964",
    code: "IQ",
    flag: "🇮🇶",
    local_name: "العراق",
    currency: "Iraqi Dinar",
    currency_code: "IQD",
    currency_symbol: "ع.د",
  },
  {
    name: "Ireland",
    dial_code: "+353",
    code: "IE",
    flag: "🇮🇪",
    local_name: "Éire",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Isle of Man",
    dial_code: "+44",
    code: "IM",
    flag: "🇮🇲",
    part_of: ["GB"],
    local_name: "Isle of Man",
    currency: "Manx Pound",
    currency_code: "IMP",
    currency_symbol: "£",
  },
  {
    name: "Israel",
    dial_code: "+972",
    code: "IL",
    flag: "🇮🇱",
    local_name: "ישראל",
    currency: "Israeli New Shekel",
    currency_code: "ILS",
    currency_symbol: "₪",
  },
  {
    name: "Italy",
    dial_code: "+39",
    code: "IT",
    flag: "🇮🇹",
    local_name: "Italia",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Jamaica",
    dial_code: "+1876",
    code: "JM",
    flag: "🇯🇲",
    local_name: "Jamaica",
    currency: "Jamaican Dollar",
    currency_code: "JMD",
    currency_symbol: "$",
    country_code: "+1",
    area_codes: ["876", "658"],
  },
  {
    name: "Jamaica",
    dial_code: "+1658",
    code: "JM",
    flag: "🇯🇲",
    secondary: !0,
    local_name: "Jamaica",
    currency: "Jamaican Dollar",
    currency_code: "JMD",
    currency_symbol: "$",
  },
  {
    name: "Japan",
    dial_code: "+81",
    code: "JP",
    flag: "🇯🇵",
    local_name: "日本",
    currency: "Japanese Yen",
    currency_code: "JPY",
    currency_symbol: "¥",
  },
  {
    name: "Jersey",
    dial_code: "+44",
    code: "JE",
    flag: "🇯🇪",
    part_of: ["GB"],
    local_name: "Jersey",
    currency: "Jersey Pound",
    currency_code: "JEP",
    currency_symbol: "£",
  },
  {
    name: "Jordan",
    dial_code: "+962",
    code: "JO",
    flag: "🇯🇴",
    local_name: "الأردن",
    currency: "Jordanian Dinar",
    currency_code: "JOD",
    currency_symbol: "د.ا",
  },
  {
    name: "Kazakhstan",
    dial_code: "+77",
    code: "KZ",
    flag: "🇰🇿",
    local_name: "Қазақстан",
    currency: "Kazakhstani Tenge",
    currency_code: "KZT",
    currency_symbol: "₸",
  },
  {
    name: "Kenya",
    dial_code: "+254",
    code: "KE",
    flag: "🇰🇪",
    local_name: "Kenya",
    currency: "Kenyan Shilling",
    currency_code: "KES",
    currency_symbol: "KSh",
  },
  {
    name: "Kiribati",
    dial_code: "+686",
    code: "KI",
    flag: "🇰🇮",
    local_name: "Kiribati",
    currency: "Australian Dollar",
    currency_code: "AUD",
    currency_symbol: "$",
  },
  {
    name: "Korea, Democratic People's Republic of",
    dial_code: "+850",
    code: "KP",
    flag: "🇰🇵",
    local_name: "조선민주주의인민공화국",
    currency: "North Korean Won",
    currency_code: "KPW",
    currency_symbol: "₩",
  },
  {
    name: "Korea, Republic of",
    dial_code: "+82",
    code: "KR",
    flag: "🇰🇷",
    local_name: "대한민국",
    currency: "South Korean Won",
    currency_code: "KRW",
    currency_symbol: "₩",
  },
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
    flag: "🇰🇼",
    local_name: "الكويت",
    currency: "Kuwaiti Dinar",
    currency_code: "KWD",
    currency_symbol: "د.ك",
  },
  {
    name: "Kyrgyzstan",
    dial_code: "+996",
    code: "KG",
    flag: "🇰🇬",
    local_name: "Кыргызстан",
    currency: "Kyrgyzstani Som",
    currency_code: "KGS",
    currency_symbol: "с",
  },
  {
    name: "Kosovo",
    dial_code: "+383",
    code: "XK",
    flag: "🇽🇰",
    local_name: "Kosova",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Lao People's Democratic Republic",
    dial_code: "+856",
    code: "LA",
    flag: "🇱🇦",
    local_name: "ປະເທດລາວ",
    currency: "Lao Kip",
    currency_code: "LAK",
    currency_symbol: "₭",
  },
  {
    name: "Latvia",
    dial_code: "+371",
    code: "LV",
    flag: "🇱🇻",
    local_name: "Latvija",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Lebanon",
    dial_code: "+961",
    code: "LB",
    flag: "🇱🇧",
    local_name: "لبنان",
    currency: "Lebanese Pound",
    currency_code: "LBP",
    currency_symbol: "ل.ل",
  },
  {
    name: "Lesotho",
    dial_code: "+266",
    code: "LS",
    flag: "🇱🇸",
    local_name: "Lesotho",
    currency: "Lesotho Loti",
    currency_code: "LSL",
    currency_symbol: "L",
  },
  {
    name: "Liberia",
    dial_code: "+231",
    code: "LR",
    flag: "🇱🇷",
    local_name: "Liberia",
    currency: "Liberian Dollar",
    currency_code: "LRD",
    currency_symbol: "$",
  },
  {
    name: "Libya",
    dial_code: "+218",
    code: "LY",
    flag: "🇱🇾",
    local_name: "ليبيا",
    currency: "Libyan Dinar",
    currency_code: "LYD",
    currency_symbol: "ل.د",
  },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    code: "LI",
    flag: "🇱🇮",
    local_name: "Liechtenstein",
    currency: "Swiss Franc",
    currency_code: "CHF",
    currency_symbol: "Fr.",
  },
  {
    name: "Lithuania",
    dial_code: "+370",
    code: "LT",
    flag: "🇱🇹",
    local_name: "Lietuva",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Luxembourg",
    dial_code: "+352",
    code: "LU",
    flag: "🇱🇺",
    local_name: "Luxembourg",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Macao",
    dial_code: "+853",
    code: "MO",
    flag: "🇲🇴",
    part_of: ["CN"],
    local_name: "澳門",
    currency: "Macanese Pataca",
    currency_code: "MOP",
    currency_symbol: "MOP$",
  },
  {
    name: "Madagascar",
    dial_code: "+261",
    code: "MG",
    flag: "🇲🇬",
    local_name: "Madagasikara",
    currency: "Malagasy Ariary",
    currency_code: "MGA",
    currency_symbol: "Ar",
  },
  {
    name: "Malawi",
    dial_code: "+265",
    code: "MW",
    flag: "🇲🇼",
    local_name: "Malawi",
    currency: "Malawian Kwacha",
    currency_code: "MWK",
    currency_symbol: "MK",
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    code: "MY",
    flag: "🇲🇾",
    local_name: "Malaysia",
    currency: "Malaysian Ringgit",
    currency_code: "MYR",
    currency_symbol: "RM",
  },
  {
    name: "Maldives",
    dial_code: "+960",
    code: "MV",
    flag: "🇲🇻",
    local_name: "ދިވެހިރާއްޖެ",
    currency: "Maldivian Rufiyaa",
    currency_code: "MVR",
    currency_symbol: "Rf",
  },
  {
    name: "Mali",
    dial_code: "+223",
    code: "ML",
    flag: "🇲🇱",
    local_name: "Mali",
    currency: "West African CFA Franc",
    currency_code: "XOF",
    currency_symbol: "CFA",
  },
  {
    name: "Malta",
    dial_code: "+356",
    code: "MT",
    flag: "🇲🇹",
    local_name: "Malta",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Marshall Islands",
    dial_code: "+692",
    code: "MH",
    flag: "🇲🇭",
    local_name: "Marshall Islands",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Martinique",
    dial_code: "+596",
    code: "MQ",
    flag: "🇲🇶",
    part_of: ["FR"],
    local_name: "Martinique",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Mauritania",
    dial_code: "+222",
    code: "MR",
    flag: "🇲🇷",
    local_name: "موريتانيا",
    currency: "Mauritanian Ouguiya",
    currency_code: "MRU",
    currency_symbol: "UM",
  },
  {
    name: "Mauritius",
    dial_code: "+230",
    code: "MU",
    flag: "🇲🇺",
    local_name: "Moris",
    currency: "Mauritian Rupee",
    currency_code: "MUR",
    currency_symbol: "₨",
  },
  {
    name: "Mayotte",
    dial_code: "+262",
    code: "YT",
    flag: "🇾🇹",
    part_of: ["FR"],
    local_name: "Mayotte",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Mexico",
    dial_code: "+52",
    code: "MX",
    flag: "🇲🇽",
    local_name: "México",
    currency: "Mexican Peso",
    currency_code: "MXN",
    currency_symbol: "$",
  },
  {
    name: "Micronesia, Federated States of",
    dial_code: "+691",
    code: "FM",
    flag: "🇫🇲",
    local_name: "Micronesia",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Moldova, Republic of",
    dial_code: "+373",
    code: "MD",
    flag: "🇲🇩",
    local_name: "Moldova",
    currency: "Moldovan Leu",
    currency_code: "MDL",
    currency_symbol: "L",
  },
  {
    name: "Monaco",
    dial_code: "+377",
    code: "MC",
    flag: "🇲🇨",
    local_name: "Monaco",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Mongolia",
    dial_code: "+976",
    code: "MN",
    flag: "🇲🇳",
    local_name: "Монгол улс",
    currency: "Mongolian Tögrög",
    currency_code: "MNT",
    currency_symbol: "₮",
  },
  {
    name: "Montenegro",
    dial_code: "+382",
    code: "ME",
    flag: "🇲🇪",
    local_name: "Crna Gora",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Montserrat",
    dial_code: "+1664",
    code: "MS",
    flag: "🇲🇸",
    local_name: "Montserrat",
    currency: "East Caribbean Dollar",
    currency_code: "XCD",
    currency_symbol: "$",
  },
  {
    name: "Morocco",
    dial_code: "+212",
    code: "MA",
    flag: "🇲🇦",
    local_name: "المغرب",
    currency: "Moroccan Dirham",
    currency_code: "MAD",
    currency_symbol: "د.م.",
  },
  {
    name: "Mozambique",
    dial_code: "+258",
    code: "MZ",
    flag: "🇲🇿",
    local_name: "Moçambique",
    currency: "Mozambican Metical",
    currency_code: "MZN",
    currency_symbol: "MT",
  },
  {
    name: "Myanmar",
    dial_code: "+95",
    code: "MM",
    flag: "🇲🇲",
    local_name: "မြန်မာ",
    currency: "Myanmar Kyat",
    currency_code: "MMK",
    currency_symbol: "K",
  },
  {
    name: "Namibia",
    dial_code: "+264",
    code: "NA",
    flag: "🇳🇦",
    local_name: "Namibia",
    currency: "Namibian Dollar",
    currency_code: "NAD",
    currency_symbol: "$",
  },
  {
    name: "Nauru",
    dial_code: "+674",
    code: "NR",
    flag: "🇳🇷",
    local_name: "Nauru",
    currency: "Australian Dollar",
    currency_code: "AUD",
    currency_symbol: "$",
  },
  {
    name: "Nepal",
    dial_code: "+977",
    code: "NP",
    flag: "🇳🇵",
    local_name: "नेपाल",
    currency: "Nepalese Rupee",
    currency_code: "NPR",
    currency_symbol: "₨",
  },
  {
    name: "Netherlands",
    dial_code: "+31",
    code: "NL",
    flag: "🇳🇱",
    local_name: "Nederland",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Caribbean Netherlands",
    dial_code: "+599",
    code: "BQ",
    flag: "🇧🇶",
    part_of: ["NL"],
    local_name: "Caribisch Nederland",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "New Caledonia",
    dial_code: "+687",
    code: "NC",
    flag: "🇳🇨",
    part_of: ["FR"],
    local_name: "Nouvelle-Calédonie",
    currency: "CFP Franc",
    currency_code: "XPF",
    currency_symbol: "₣",
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    code: "NZ",
    flag: "🇳🇿",
    local_name: "New Zealand",
    currency: "New Zealand Dollar",
    currency_code: "NZD",
    currency_symbol: "$",
  },
  {
    name: "Nicaragua",
    dial_code: "+505",
    code: "NI",
    flag: "🇳🇮",
    local_name: "Nicaragua",
    currency: "Nicaraguan Córdoba",
    currency_code: "NIO",
    currency_symbol: "C$",
  },
  {
    name: "Niger",
    dial_code: "+227",
    code: "NE",
    flag: "🇳🇪",
    local_name: "Niger",
    currency: "West African CFA Franc",
    currency_code: "XOF",
    currency_symbol: "CFA",
  },
  {
    name: "Nigeria",
    dial_code: "+234",
    code: "NG",
    flag: "🇳🇬",
    local_name: "Nigeria",
    currency: "Nigerian Naira",
    currency_code: "NGN",
    currency_symbol: "₦",
  },
  {
    name: "Niue",
    dial_code: "+683",
    code: "NU",
    flag: "🇳🇺",
    local_name: "Niuē",
    currency: "New Zealand Dollar",
    currency_code: "NZD",
    currency_symbol: "$",
  },
  {
    name: "Norfolk Island",
    dial_code: "+672",
    code: "NF",
    flag: "🇳🇫",
    part_of: ["AU"],
    local_name: "Norfolk Island",
    currency: "Australian Dollar",
    currency_code: "AUD",
    currency_symbol: "$",
  },
  {
    name: "North Macedonia",
    dial_code: "+389",
    code: "MK",
    flag: "🇲🇰",
    local_name: "Северна Македонија",
    currency: "Macedonian Denar",
    currency_code: "MKD",
    currency_symbol: "ден",
  },
  {
    name: "Northern Mariana Islands",
    dial_code: "+1670",
    code: "MP",
    flag: "🇲🇵",
    part_of: ["US"],
    local_name: "Northern Mariana Islands",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Norway",
    dial_code: "+47",
    code: "NO",
    flag: "🇳🇴",
    local_name: "Norge",
    currency: "Norwegian Krone",
    currency_code: "NOK",
    currency_symbol: "kr",
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
    flag: "🇴🇲",
    local_name: "عُمان",
    currency: "Omani Rial",
    currency_code: "OMR",
    currency_symbol: "ر.ع.",
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    flag: "🇵🇰",
    local_name: "پاکستان",
    currency: "Pakistani Rupee",
    currency_code: "PKR",
    currency_symbol: "₨",
  },
  {
    name: "Palau",
    dial_code: "+680",
    code: "PW",
    flag: "🇵🇼",
    local_name: "Palau",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Palestine, State of",
    dial_code: "+970",
    code: "PS",
    flag: "🇵🇸",
    local_name: "فلسطين",
    currency: "Israeli New Shekel",
    currency_code: "ILS",
    currency_symbol: "₪",
  },
  {
    name: "Panama",
    dial_code: "+507",
    code: "PA",
    flag: "🇵🇦",
    local_name: "Panamá",
    currency: "Panamanian Balboa",
    currency_code: "PAB",
    currency_symbol: "B/.",
  },
  {
    name: "Papua New Guinea",
    dial_code: "+675",
    code: "PG",
    flag: "🇵🇬",
    local_name: "Papua New Guinea",
    currency: "Papua New Guinean Kina",
    currency_code: "PGK",
    currency_symbol: "K",
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    code: "PY",
    flag: "🇵🇾",
    local_name: "Paraguay",
    currency: "Paraguayan Guaraní",
    currency_code: "PYG",
    currency_symbol: "₲",
  },
  {
    name: "Peru",
    dial_code: "+51",
    code: "PE",
    flag: "🇵🇪",
    local_name: "Perú",
    currency: "Peruvian Sol",
    currency_code: "PEN",
    currency_symbol: "S/.",
  },
  {
    name: "Philippines",
    dial_code: "+63",
    code: "PH",
    flag: "🇵🇭",
    local_name: "Pilipinas",
    currency: "Philippine Peso",
    currency_code: "PHP",
    currency_symbol: "₱",
  },
  {
    name: "Pitcairn",
    dial_code: "+872",
    code: "PN",
    flag: "🇵🇳",
    part_of: ["GB"],
    local_name: "Pitcairn Islands",
    currency: "New Zealand Dollar",
    currency_code: "NZD",
    currency_symbol: "$",
  },
  {
    name: "Poland",
    dial_code: "+48",
    code: "PL",
    flag: "🇵🇱",
    local_name: "Polska",
    currency: "Polish Złoty",
    currency_code: "PLN",
    currency_symbol: "zł",
  },
  {
    name: "Portugal",
    dial_code: "+351",
    code: "PT",
    flag: "🇵🇹",
    local_name: "Portugal",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Puerto Rico",
    dial_code: "+1939",
    code: "PR",
    flag: "🇵🇷",
    country_code: "+1",
    area_codes: ["939", "787"],
    part_of: ["US"],
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Puerto Rico",
    dial_code: "+1787",
    code: "PR",
    flag: "🇵🇷",
    secondary: !0,
    part_of: ["US"],
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
    flag: "🇶🇦",
    local_name: "قطر",
    currency: "Qatari Riyal",
    currency_code: "QAR",
    currency_symbol: "ر.ق",
  },
  {
    name: "Romania",
    dial_code: "+40",
    code: "RO",
    flag: "🇷🇴",
    local_name: "România",
    currency: "Romanian Leu",
    currency_code: "RON",
    currency_symbol: "lei",
  },
  {
    name: "Russia",
    dial_code: "+7",
    code: "RU",
    flag: "🇷🇺",
    local_name: "Россия",
    currency: "Russian Ruble",
    currency_code: "RUB",
    currency_symbol: "₽",
  },
  {
    name: "Rwanda",
    dial_code: "+250",
    code: "RW",
    flag: "🇷🇼",
    local_name: "Rwanda",
    currency: "Rwandan Franc",
    currency_code: "RWF",
    currency_symbol: "FRw",
  },
  {
    name: "Réunion",
    dial_code: "+262",
    code: "RE",
    flag: "🇷🇪",
    part_of: ["FR"],
    local_name: "La Réunion",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Saint Barthélemy",
    dial_code: "+590",
    code: "BL",
    flag: "🇧🇱",
    part_of: ["FR"],
    local_name: "Saint-Barthélemy",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dial_code: "+290",
    code: "SH",
    flag: "🇸🇭",
    part_of: ["GB"],
    local_name: "Saint Helena",
    currency: "Saint Helena Pound",
    currency_code: "SHP",
    currency_symbol: "£",
  },
  {
    name: "Saint Kitts and Nevis",
    dial_code: "+1869",
    code: "KN",
    flag: "🇰🇳",
    local_name: "Saint Kitts and Nevis",
    currency: "East Caribbean Dollar",
    currency_code: "XCD",
    currency_symbol: "$",
  },
  {
    name: "Saint Lucia",
    dial_code: "+1758",
    code: "LC",
    flag: "🇱🇨",
    local_name: "Saint Lucia",
    currency: "East Caribbean Dollar",
    currency_code: "XCD",
    currency_symbol: "$",
  },
  {
    name: "Saint Martin",
    dial_code: "+590",
    code: "MF",
    flag: "🇲🇫",
    part_of: ["FR"],
    local_name: "Saint-Martin",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Saint Pierre and Miquelon",
    dial_code: "+508",
    code: "PM",
    flag: "🇵🇲",
    part_of: ["FR"],
    local_name: "Saint-Pierre-et-Miquelon",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Saint Vincent and the Grenadines",
    dial_code: "+1784",
    code: "VC",
    flag: "🇻🇨",
    local_name: "Saint Vincent and the Grenadines",
    currency: "East Caribbean Dollar",
    currency_code: "XCD",
    currency_symbol: "$",
  },
  {
    name: "Samoa",
    dial_code: "+685",
    code: "WS",
    flag: "🇼🇸",
    local_name: "Samoa",
    currency: "Samoan Tālā",
    currency_code: "WST",
    currency_symbol: "T",
  },
  {
    name: "San Marino",
    dial_code: "+378",
    code: "SM",
    flag: "🇸🇲",
    local_name: "San Marino",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Sao Tome and Principe",
    dial_code: "+239",
    code: "ST",
    flag: "🇸🇹",
    local_name: "São Tomé e Príncipe",
    currency: "São Tomé and Príncipe Dobra",
    currency_code: "STN",
    currency_symbol: "Db",
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
    flag: "🇸🇦",
    local_name: "المملكة العربية السعودية",
    currency: "Saudi Riyal",
    currency_code: "SAR",
    currency_symbol: "ر.س",
  },
  {
    name: "Senegal",
    dial_code: "+221",
    code: "SN",
    flag: "🇸🇳",
    local_name: "Sénégal",
    currency: "West African CFA Franc",
    currency_code: "XOF",
    currency_symbol: "CFA",
  },
  {
    name: "Serbia",
    dial_code: "+381",
    code: "RS",
    flag: "🇷🇸",
    local_name: "Србија",
    currency: "Serbian Dinar",
    currency_code: "RSD",
    currency_symbol: "дин.",
  },
  {
    name: "Seychelles",
    dial_code: "+248",
    code: "SC",
    flag: "🇸🇨",
    local_name: "Seychelles",
    currency: "Seychellois Rupee",
    currency_code: "SCR",
    currency_symbol: "₨",
  },
  {
    name: "Sierra Leone",
    dial_code: "+232",
    code: "SL",
    flag: "🇸🇱",
    local_name: "Sierra Leone",
    currency: "Sierra Leonean Leone",
    currency_code: "SLL",
    currency_symbol: "Le",
  },
  {
    name: "Singapore",
    dial_code: "+65",
    code: "SG",
    flag: "🇸🇬",
    local_name: "Singapore",
    currency: "Singapore Dollar",
    currency_code: "SGD",
    currency_symbol: "$",
  },
  {
    name: "Sint Maarten",
    dial_code: "+1721",
    code: "SX",
    flag: "🇸🇽",
    part_of: ["NL"],
    local_name: "Sint Maarten",
    currency: "Netherlands Antillean Guilder",
    currency_code: "ANG",
    currency_symbol: "ƒ",
  },
  {
    name: "Slovakia",
    dial_code: "+421",
    code: "SK",
    flag: "🇸🇰",
    local_name: "Slovensko",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Slovenia",
    dial_code: "+386",
    code: "SI",
    flag: "🇸🇮",
    local_name: "Slovenija",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Solomon Islands",
    dial_code: "+677",
    code: "SB",
    flag: "🇸🇧",
    local_name: "Solomon Islands",
    currency: "Solomon Islands Dollar",
    currency_code: "SBD",
    currency_symbol: "$",
  },
  {
    name: "Somalia",
    dial_code: "+252",
    code: "SO",
    flag: "🇸🇴",
    local_name: "الصومال",
    currency: "Somali Shilling",
    currency_code: "SOS",
    currency_symbol: "Sh.So.",
  },
  {
    name: "South Africa",
    dial_code: "+27",
    code: "ZA",
    flag: "🇿🇦",
    local_name: "South Africa",
    currency: "South African Rand",
    currency_code: "ZAR",
    currency_symbol: "R",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    dial_code: "+500",
    code: "GS",
    flag: "🇬🇸",
    part_of: ["GB"],
    local_name: "South Georgia",
    currency: "British Pound",
    currency_code: "GBP",
    currency_symbol: "£",
  },
  {
    name: "South Sudan",
    dial_code: "+211",
    code: "SS",
    flag: "🇸🇸",
    local_name: "South Sudan",
    currency: "South Sudanese Pound",
    currency_code: "SSP",
    currency_symbol: "£",
  },
  {
    name: "Spain",
    dial_code: "+34",
    code: "ES",
    flag: "🇪🇸",
    local_name: "España",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    code: "LK",
    flag: "🇱🇰",
    local_name: "ශ්‍රී ලංකාව",
    currency: "Sri Lankan Rupee",
    currency_code: "LKR",
    currency_symbol: "₨",
  },
  {
    name: "Sudan",
    dial_code: "+249",
    code: "SD",
    flag: "🇸🇩",
    local_name: "السودان",
    currency: "Sudanese Pound",
    currency_code: "SDG",
    currency_symbol: "ج.س.",
  },
  {
    name: "Suriname",
    dial_code: "+597",
    code: "SR",
    flag: "🇸🇷",
    local_name: "Suriname",
    currency: "Surinamese Dollar",
    currency_code: "SRD",
    currency_symbol: "$",
  },
  {
    name: "Svalbard and Jan Mayen",
    dial_code: "+47",
    code: "SJ",
    flag: "🇸🇯",
    part_of: ["NO"],
    local_name: "Svalbard og Jan Mayen",
    currency: "Norwegian Krone",
    currency_code: "NOK",
    currency_symbol: "kr",
  },
  {
    name: "Sweden",
    dial_code: "+46",
    code: "SE",
    flag: "🇸🇪",
    local_name: "Sverige",
    currency: "Swedish Krona",
    currency_code: "SEK",
    currency_symbol: "kr",
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    code: "CH",
    flag: "🇨🇭",
    local_name: "Schweiz",
    currency: "Swiss Franc",
    currency_code: "CHF",
    currency_symbol: "Fr.",
  },
  {
    name: "Syrian Arab Republic",
    dial_code: "+963",
    code: "SY",
    flag: "🇸🇾",
    local_name: "سورية",
    currency: "Syrian Pound",
    currency_code: "SYP",
    currency_symbol: "£S",
  },
  {
    name: "Taiwan, Province of China",
    dial_code: "+886",
    code: "TW",
    flag: "🇹🇼",
    local_name: "台灣",
    currency: "New Taiwan Dollar",
    currency_code: "TWD",
    currency_symbol: "NT$",
  },
  {
    name: "Tajikistan",
    dial_code: "+992",
    code: "TJ",
    flag: "🇹🇯",
    local_name: "Тоҷикистон",
    currency: "Tajikistani Somoni",
    currency_code: "TJS",
    currency_symbol: "ЅМ",
  },
  {
    name: "Tanzania, United Republic of",
    dial_code: "+255",
    code: "TZ",
    flag: "🇹🇿",
    local_name: "Tanzania",
    currency: "Tanzanian Shilling",
    currency_code: "TZS",
    currency_symbol: "TSh",
  },
  {
    name: "Thailand",
    dial_code: "+66",
    code: "TH",
    flag: "🇹🇭",
    local_name: "ประเทศไทย",
    currency: "Thai Baht",
    currency_code: "THB",
    currency_symbol: "฿",
  },
  {
    name: "Timor-Leste",
    dial_code: "+670",
    code: "TL",
    flag: "🇹🇱",
    local_name: "Timor-Leste",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Togo",
    dial_code: "+228",
    code: "TG",
    flag: "🇹🇬",
    local_name: "Togo",
    currency: "West African CFA Franc",
    currency_code: "XOF",
    currency_symbol: "CFA",
  },
  {
    name: "Tokelau",
    dial_code: "+690",
    code: "TK",
    flag: "🇹🇰",
    local_name: "Tokelau",
    currency: "New Zealand Dollar",
    currency_code: "NZD",
    currency_symbol: "$",
  },
  {
    name: "Tonga",
    dial_code: "+676",
    code: "TO",
    flag: "🇹🇴",
    local_name: "Tonga",
    currency: "Tongan Paʻanga",
    currency_code: "TOP",
    currency_symbol: "T$",
  },
  {
    name: "Trinidad and Tobago",
    dial_code: "+1868",
    code: "TT",
    flag: "🇹🇹",
    local_name: "Trinidad and Tobago",
    currency: "Trinidad and Tobago Dollar",
    currency_code: "TTD",
    currency_symbol: "$",
  },
  {
    name: "Tunisia",
    dial_code: "+216",
    code: "TN",
    flag: "🇹🇳",
    local_name: "تونس",
    currency: "Tunisian Dinar",
    currency_code: "TND",
    currency_symbol: "د.ت",
  },
  {
    name: "Turkey",
    dial_code: "+90",
    code: "TR",
    flag: "🇹🇷",
    local_name: "Türkiye",
    currency: "Turkish Lira",
    currency_code: "TRY",
    currency_symbol: "₺",
  },
  {
    name: "Türkiye",
    dial_code: "+90",
    code: "TR",
    flag: "🇹🇷",
    local_name: "Türkiye",
    currency: "Turkish Lira",
    currency_code: "TRY",
    currency_symbol: "₺",
    secondary: !0,
  },
  {
    name: "Turkmenistan",
    dial_code: "+993",
    code: "TM",
    flag: "🇹🇲",
    local_name: "Türkmenistan",
    currency: "Turkmenistan Manat",
    currency_code: "TMT",
    currency_symbol: "m",
  },
  {
    name: "Turks and Caicos Islands",
    dial_code: "+1649",
    code: "TC",
    flag: "🇹🇨",
    part_of: ["GB"],
    local_name: "Turks and Caicos Islands",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Tuvalu",
    dial_code: "+688",
    code: "TV",
    flag: "🇹🇻",
    local_name: "Tuvalu",
    currency: "Australian Dollar",
    currency_code: "AUD",
    currency_symbol: "$",
  },
  {
    name: "Uganda",
    dial_code: "+256",
    code: "UG",
    flag: "🇺🇬",
    local_name: "Uganda",
    currency: "Ugandan Shilling",
    currency_code: "UGX",
    currency_symbol: "USh",
  },
  {
    name: "Ukraine",
    dial_code: "+380",
    code: "UA",
    flag: "🇺🇦",
    local_name: "Україна",
    currency: "Ukrainian Hryvnia",
    currency_code: "UAH",
    currency_symbol: "₴",
  },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    code: "AE",
    preferred: !0,
    flag: "🇦🇪",
    local_name: "الإمارات العربية المتحدة",
    currency: "UAE Dirham",
    currency_code: "AED",
    currency_symbol: "د.إ",
  },
  {
    name: "United Kingdom",
    dial_code: "+44",
    code: "GB",
    preferred: !0,
    flag: "🇬🇧",
    local_name: "United Kingdom",
    currency: "British Pound",
    currency_code: "GBP",
    currency_symbol: "£",
  },
  {
    name: "United States",
    dial_code: "+1",
    code: "US",
    preferred: !0,
    flag: "🇺🇸",
    local_name: "United States",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Uruguay",
    dial_code: "+598",
    code: "UY",
    flag: "🇺🇾",
    local_name: "Uruguay",
    currency: "Uruguayan Peso",
    currency_code: "UYU",
    currency_symbol: "$",
  },
  {
    name: "Uzbekistan",
    dial_code: "+998",
    code: "UZ",
    flag: "🇺🇿",
    local_name: "O'zbekiston",
    currency: "Uzbekistani Som",
    currency_code: "UZS",
    currency_symbol: "лв",
  },
  {
    name: "Vanuatu",
    dial_code: "+678",
    code: "VU",
    flag: "🇻🇺",
    local_name: "Vanuatu",
    currency: "Vanuatu Vatu",
    currency_code: "VUV",
    currency_symbol: "VT",
  },
  {
    name: "Venezuela, Bolivarian Republic of",
    dial_code: "+58",
    code: "VE",
    flag: "🇻🇪",
    local_name: "Venezuela",
    currency: "Venezuelan Bolívar",
    currency_code: "VES",
    currency_symbol: "Bs.",
  },
  {
    name: "Vietnam",
    dial_code: "+84",
    code: "VN",
    flag: "🇻🇳",
    local_name: "Việt Nam",
    currency: "Vietnamese Đồng",
    currency_code: "VND",
    currency_symbol: "₫",
  },
  {
    name: "Virgin Islands, British",
    dial_code: "+1284",
    code: "VG",
    flag: "🇻🇬",
    part_of: ["GB"],
    local_name: "British Virgin Islands",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Virgin Islands, U.S.",
    dial_code: "+1340",
    code: "VI",
    flag: "🇻🇮",
    part_of: ["US"],
    local_name: "U.S. Virgin Islands",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Wallis and Futuna",
    dial_code: "+681",
    code: "WF",
    flag: "🇼🇫",
    local_name: "Wallis-et-Futuna",
    currency: "CFP Franc",
    currency_code: "XPF",
    currency_symbol: "₣",
  },
  {
    name: "Western Sahara",
    dial_code: "+212",
    code: "EH",
    flag: "🇪🇭",
    local_name: "الصحراء الغربية",
    currency: "Moroccan Dirham",
    currency_code: "MAD",
    currency_symbol: "د.م.",
  },
  {
    name: "Yemen",
    dial_code: "+967",
    code: "YE",
    flag: "🇾🇪",
    local_name: "اليمن",
    currency: "Yemeni Rial",
    currency_code: "YER",
    currency_symbol: "﷼",
  },
  {
    name: "Zambia",
    dial_code: "+260",
    code: "ZM",
    flag: "🇿🇲",
    local_name: "Zambia",
    currency: "Zambian Kwacha",
    currency_code: "ZMW",
    currency_symbol: "ZK",
  },
  {
    name: "Zimbabwe",
    dial_code: "+263",
    code: "ZW",
    flag: "🇿🇼",
    local_name: "Zimbabwe",
    currency: "US Dollar",
    currency_code: "USD",
    currency_symbol: "$",
  },
  {
    name: "Åland Islands",
    dial_code: "+358",
    code: "AX",
    flag: "🇦🇽",
    part_of: ["FI"],
    local_name: "Åland",
    currency: "Euro",
    currency_code: "EUR",
    currency_symbol: "€",
  },
];
